import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ACTIVATION_ERRORS, ERRORS, NOTIFICATION_KEYWORDS, REGEX, URL_PARAMS } from "../../../constants";
import { AuthService } from "../../../services/auth.service";
import { NotificationService } from "../../../services/notification.service";
import { UtilityService } from "../../../services/utility.service";

@Component( {
	selector: "app-account-activation",
	templateUrl: "./account-activation.component.html",
	styleUrls: [ "./account-activation.component.scss" ]
} )

export class AccountActivationComponent implements OnInit {

	accountActivationForm: FormGroup;
	email: string;
	code: string;
	url: string = window.location.href;
	isCodeExpired: boolean = false;
	queryParams;

	constructor(
		private formBuilder: FormBuilder,
		private route: ActivatedRoute,
		private notificationService: NotificationService,
		private authService: AuthService,
		private utilityService: UtilityService,
		private spinnerService: NgxSpinnerService,
		private activatedRoute: ActivatedRoute
	) {
		this.activatedRoute.queryParams.subscribe((params) => {
			this.queryParams = params;
		});
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe( () => {
			this.email = this.queryParams[URL_PARAMS.EMAIL];
			this.code = this.queryParams[URL_PARAMS.CODE];
		} );

		this.accountActivationForm = this.formBuilder.group( {
			email: [ { value: this.email, disabled: true }, [ Validators.required ] ]
		} );

		this.accountActivationForm.valueChanges.subscribe( ( value ) => {
			const emailRegex = REGEX.EMAIL;

			if ( value.email && value.email.endsWith( "@" ) ) {
				this.accountActivationForm.controls["email"].setErrors( { "incompleteEmail": true } );
			} else if ( value.email && !value.email.match( emailRegex ) ) {
				this.accountActivationForm.controls["email"].setErrors( { "invalidEmail": true } );
			}
		} );
	}

	/**
	 * Handle account activation functionality
	 */
	submitAccountActivation(): void {

		const data = {
			code: this.code,
			email: this.accountActivationForm.controls["email"].value
		};
		this.spinnerService.show();
		this.authService.activation( data, this.queryParams[URL_PARAMS.TYPE] ).subscribe( response => {
			if ( response ) {
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.ACCOUNT_ACTIVATED );
				this.utilityService.redirectToLoginPage();
				this.spinnerService.hide();
			}
		}, ( error ) => {
			if ( error.error.message === ACTIVATION_ERRORS.ALREADY_ACTIVATED ) {
				this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.ALREADY_ACTIVATED );
				this.utilityService.redirectToLoginPage();
				this.spinnerService.hide();
				return;
			}
			this.isCodeExpired = true;
			this.spinnerService.hide();
			this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.ACCOUNT_ACTIVATION );
			if(this.accountActivationForm.controls["email"].value) {
				error.email = this.accountActivationForm.controls["email"].value;
			}
		} );
	}

	/**
	 * Handle resend account activation link functionality
	 */
	submitResendAccountActivationForm(): void {
		for ( const control in this.accountActivationForm.controls ) {
			this.accountActivationForm.controls[control].markAsDirty();
			this.accountActivationForm.controls[control].updateValueAndValidity();
		}

		const data = {
			email: this.accountActivationForm.controls["email"].value
		};
		this.spinnerService.show();
		this.authService.sendActivationLink( data, this.queryParams[URL_PARAMS.TYPE] ).subscribe( response => {

			if ( response ) {
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.RESEND_ACCOUNT_ACTIVATION );
				this.utilityService.redirectToLoginPage();
				this.spinnerService.hide();
			}
		}, ( error ) => {
			if ( error ) {
				this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.ACCOUNT_ACTIVATION_LINK );
				this.spinnerService.hide();
			}
		} );
	}
}
